import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import FichaExpediente from './fichaExpediente';
import ListaTrabajos from './listaTrabajos';
import TipoExpediente from './tipoExpediente';
import Substituciones from "./Substituciones"
import {CODIGO_FORMATO_DIGITAL} from "../../../../api/config";


class ExpedienteGeneral extends Component {

    render() {

        const datosExpediente=this.props.expediente;
        
        const disabledEdit = datosExpediente && datosExpediente.Trabajos
        && datosExpediente.Trabajos.some(x => x.Id_Estado >= 3);

        const esSubstitucion = datosExpediente.Expediente[0].Substitucion;
        const esExpDigital = (datosExpediente.Expediente[0].Expediente_Codigo_Archivo || '').toString().startsWith(CODIGO_FORMATO_DIGITAL) 
        || datosExpediente.Expediente[0].Expediente_Codigo_Archivo==null;   
     
        
        return (
            <Grid container spacing={0}>
              
            <Grid item md={4} xs={12} >

              <FichaExpediente disable={false} expediente={datosExpediente}
                  sourceExpediente={datosExpediente.Expediente.length > 0 ? datosExpediente.Expediente[0] : {}}
                    updateExpediente={(expediente) => this.props.updateExpediente(expediente)} 
                    />        

                 {(esSubstitucion==1 || !disabledEdit) && esExpDigital? 
                     <Substituciones disable={false} expediente={datosExpediente}
                    sourceExpediente={datosExpediente.Expediente.length > 0 ? datosExpediente.Expediente[0] : {}}
                    updateExpediente={(expediente) => this.props.updateExpediente(expediente)}                     
                    />   : null
                    }
            </Grid>  
                  

            <Grid item md={4} xs={12} >
                <TipoExpediente expediente={datosExpediente} 
                    sourceExpediente={datosExpediente.Expediente.length > 0 ? datosExpediente.Expediente[0] : {}} 
                    /> 

            </Grid>

            <Grid item md={4/*6*/} xs={12} >
                <ListaTrabajos
                        changeEstructura={(idTrabajo,idTipoTrabajo) => this.props.changeEstructura(idTrabajo,idTipoTrabajo)}
                    expediente={datosExpediente} 
                        />
                  
                </Grid>
            </Grid>
        );
    }
}

export default ExpedienteGeneral;